import { useEffect, useRef } from 'react';

const capabilities = [
  { icon: 'ri-exchange-line', title: 'Physical Commodity Trading', desc: 'Direct buying and selling of physical commodities across global markets with reliable delivery guarantees.' },
  { icon: 'ri-global-line', title: 'Global Sourcing & Procurement', desc: 'Extensive supplier network enabling competitive and consistent sourcing across multiple commodity sectors.' },
  { icon: 'ri-links-line', title: 'Supply Chain Coordination', desc: 'End-to-end supply chain management from producer to end consumer with seamless logistics execution.' },
  { icon: 'ri-team-line', title: 'Network Development', desc: 'Building and nurturing supplier and customer relationships across Asia, Europe, Americas, Africa, and the Middle East.' },
  { icon: 'ri-ship-line', title: 'Freight & Logistics Management', desc: 'Comprehensive shipping and freight solutions.' },
  { icon: 'ri-shield-check-line', title: 'Risk Management Solutions', desc: 'Structured approaches to commodity market risks, ensuring stable and predictable trade execution.' },
];

export default function CoreBusiness() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.reveal-item').forEach((el, i) => {
              setTimeout(() => {
                (el as HTMLElement).style.opacity = '1';
                (el as HTMLElement).style.transform = 'translateY(0)';
              }, i * 100);
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="business" className="bg-[#F5F5F5] py-28" ref={sectionRef}>
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">

        {/* Header */}
        <div className="reveal-item opacity-0 translate-y-8 transition-all duration-700 mb-4 text-center">
          <span className="inline-block border border-[#2A2A2A]/20 rounded-full px-6 py-2 text-[#2A2A2A] text-xs uppercase tracking-[0.3em]">
            What We Do
          </span>
        </div>
        <div className="reveal-item opacity-0 translate-y-8 transition-all duration-700 text-center mb-6">
          <h2 className="text-4xl md:text-5xl font-playfair text-[#2A2A2A]">Core Business Activities</h2>
        </div>
        <div className="reveal-item opacity-0 translate-y-8 transition-all duration-700 text-center mb-16">
          <p className="text-[#6A6A6A] text-lg max-w-2xl mx-auto leading-relaxed">
            Bulk Ore focuses on the international sourcing, marketing, and distribution of essential raw materials supporting global production, infrastructure development, and agriculture.
          </p>
        </div>

        {/* Capabilities Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {capabilities.map((cap, i) => (
            <div
              key={i}
              className="reveal-item opacity-0 translate-y-8 transition-all duration-700"
            >
              <div className="bg-white rounded-2xl p-7 h-full border border-[#E0E0E0] hover:border-[#888888] transition-all duration-300 hover:-translate-y-1 group">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#3A3A3A] mb-5 group-hover:bg-[#4A4A4A] transition-colors duration-300">
                  <i className={`${cap.icon} text-white text-xl`} />
                </div>
                <h3 className="text-[#2A2A2A] font-semibold text-base mb-3 leading-snug">{cap.title}</h3>
                <p className="text-[#6A6A6A] text-sm leading-relaxed">{cap.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
